module.exports = __webpack_public_path__ + "img/1618786832.470b9389.png";